// eslint-disable-next-line no-shadow
export enum FormFieldState {
    Hidden = 0,
    Disabled = 1,
    Visible = 2,
    Required = 3,
    ReadOnly = 4,
}
